import { isValidEmail } from './isValidEmail';
import { isValidPhone } from './isValidPhone';

export default function extractEmailAddressesAndPhoneNumbers(
    inputText: string,
    respondentEmailAddresses: string[],
    respondentPhoneNumbers: string[],
): { emailAddresses: string[]; phoneNumbers: string[] } {
    const emailAddresses: string[] = [];
    const phoneNumbers: string[] = [];

    // replace tab, LF and CR with commas
    let text = inputText
        .replace(/\t/g, ',')
        .replace(/\n/g, ',')
        .replace(/\r/g, ',');

    //replace characters
    const replaceChars = [';', '/'];
    text = replaceText(text, replaceChars);
    //console.log(tempRespondents)

    text.split(',')
        .map((text) => text.trim())
        .forEach((text) => {
            if (isValidEmail(text)) {
                if (
                    emailAddresses.indexOf(text) === -1 &&
                    respondentEmailAddresses.indexOf(text) === -1
                ) {
                    emailAddresses.push(text);
                }
            } else if (isValidPhone(text)) {
                if (
                    isUniquePhoneNumber(text, phoneNumbers) &&
                    isUniquePhoneNumber(text, respondentPhoneNumbers)
                ) {
                    phoneNumbers.push(text);
                }
            }
        });
    return {
        emailAddresses,
        phoneNumbers,
    };
}

// This function extract emails and phones but the item is not passed to a validation utils.
// Like `isValidEmail`. We intentionally do this to be able we can recognise what item is
// valid or not and show to the user the distinction via CSS.
// export function extractEmailAddressesAndPhoneNumbersButNoValidation(
//     text: string,
//     respondentEmailAddresses: string[],
//     respondentPhoneNumbers: string[],
// ): { emailAddresses: string[]; phoneNumbers: string[] } {
//     const emailAddresses: string[] = [];
//     const phoneNumbers: string[] = [];
//
//     text = text.replace(/\t/g, ',').replace(/\n/g, ',').replace(/\r/g, ',');
//
//     const replaceChars = [';', '/'];
//     text = replaceText(text, replaceChars);
//
//     text.split(',')
//         .map((text) => text.trim())
//         .forEach((text) => {
//             if (
//                 !isValidPhone(text) &&
//                 Boolean(text) &&
//                 text.includes('@') &&
//                 !emailAddresses.includes(text) &&
//                 !respondentEmailAddresses.includes(text)
//             ) {
//                 emailAddresses.push(text);
//             } else if (
//                 isValidPhone(text) &&
//                 isUniquePhoneNumber(text, phoneNumbers) &&
//                 isUniquePhoneNumber(text, respondentPhoneNumbers)
//             ) {
//                 phoneNumbers.push(text);
//             }
//         });
//     return {
//         emailAddresses,
//         phoneNumbers,
//     };
// }

/**
 * @param {String} phoneNumber
 * @param {Array<String>} phoneNumbers
 * @return {Boolean}
 */
function isUniquePhoneNumber(phoneNumber: string, phoneNumbers: string[]) {
    // https://www.twilio.com/docs/glossary/what-e164
    // Normalize by only keeping digits (and + sign?)
    const regex = /[^0-9+]/gi;
    const normalizedPhoneNumber = phoneNumber.replace(regex, '');

    return !phoneNumbers.some(
        (existingPhoneNumber: string) =>
            existingPhoneNumber.replace(regex, '') === normalizedPhoneNumber,
    );
}

function replaceText(textString: string, find: string[] = []): string {
    let replaceResult = textString.toLowerCase();
    find.forEach((f) => {
        const regex = new RegExp(f, 'g');
        replaceResult = replaceResult.replace(regex, ',');
    });
    return replaceResult;
}
